import type { ApiReportResponse, TabularDataResponse } from "../../../../../api/types/svTypes.ts";

export const isApiReportResponse = (data: ApiReportResponse | TabularDataResponse): data is ApiReportResponse => {
  return (data as ApiReportResponse).publicResponse !== undefined;
};
